import React, { useEffect, useState, useMemo, useRef } from 'react';

import * as MF from 'src/components/base/fields/MultiselectField';
import * as QA from 'shared/utils/queryAnalysis'


const Ftn = QA.FieldTypeName;
export const SupportedTypes = [Ftn.Picklist, Ftn.Multipicklist];


const Data = {
  separator: QA.Separator.MultiselectPicklist,
};


export function PicklistField({ rawField, showLabels = false, includeNotSelected = false, converters, ...restProps }) {
  const { options, isMultiselect } = useMemo(
    () => getOptions(rawField, { showLabels, includeNotSelected })
  , [rawField, showLabels, includeNotSelected]);

  const defaultConverters = useMemo(
    () => MF.mergeConverters(converters, { options, isMultiselect, separator: Data.separator })
    , [rawField, converters]);
  
    // console.log('Rendering Pickilist: ', restProps);
  return (
    <MF.MultiselectField
      {...restProps}
      // text={restProps.value}
      converters={defaultConverters}
      options={options}
      isMultiselect={isMultiselect}
    />
  );
}


export function getDefaultOption(rawField) {
  const isMultiselect = QA.isMultiselectPicklistField(rawField);
  if (isMultiselect) {
    return null;
  } 

  const active = rawField.picklistValues.filter(x => x.active);
  const def = active.find(x => x.defaultValue);
  return def ?? (active.length ? active[active.length - 1] : null);
}


export function getOptions(rawField, { showLabels = false, includeNotSelected = false } = {}) {
  const isMultiselect = QA.isMultiselectPicklistField(rawField);
  const isRestricted = QA.isRestrictedPicklistField(rawField);
  const options = rawField.picklistValues.reduce((out, x) => {
    const { label, value, active } = x; 
    active && out.push({ key: value, id: value, value, label, text: showLabels ? label : value });
    // active && out.push({ key: value, id: value, value, label, text: `${label} / ${value}` });
    return out;
  }, includeNotSelected && !isMultiselect ? [{ text: 'Not selected' }] : []); 

  return { isMultiselect, isRestricted, options };
}


export default PicklistField;